import { useContext, useEffect } from "react";

import { MktgDataContext } from "@swa-ui/application";
import { useLocation } from "@swa-ui/browser";

import { ROUTES } from "./defines/routes";

export function FmDotcomLandingAnalytics() {
  const { pathname } = useLocation();
  const { setMktgPageData } = useContext(MktgDataContext);

  useEffect(() => {
    if (pathname === ROUTES.vacations.manageMyBooking) {
      vacationsManageMyBookingTracking();
    }
  }, [pathname]);

  function vacationsManageMyBookingTracking() {
    setMktgPageData(
      {
        vacationbannerdisplayed: "1",
      },
      "vacationsManageMyBooking"
    );
  }
}
